import type { Identifier } from "ra-core";

import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import { channelColorStyle } from "./channelColors";
import { useNoteChannel } from "./useNoteChannel";

/**
 * A note's channel, wherever the note is shown. Renders nothing for a note
 * without one. Outlined in the channel's colour when it has one. LCCRM-87.
 */
export const ChannelBadge = ({
  channelId,
  className,
}: {
  channelId: Identifier | null | undefined;
  className?: string;
}) => {
  const channel = useNoteChannel(channelId);
  if (!channel) return null;

  return (
    <Badge
      variant="outline"
      className={cn("shrink-0 text-[10px] font-normal", className)}
      style={channelColorStyle(channel.color)}
    >
      {channel.name}
    </Badge>
  );
};
